import React from 'react';

const IMG_API = "https://image.tmdb.org/t/p/w1280";

const setVoteClass = (vote) => {
    if( vote >= 8 ){
        return 'green';
    }
    else if( vote >= 6 ){
        return 'orange';
    }
    else{
        return 'red';
    }
};

const Movie = ({ title, poster_path, overview, vote_average }) => (
    <div className="movie">
        <div className="movie-img">
            <img src={IMG_API+poster_path} alt={title} />
        </div>
        <div className="movie-info">
            <h3>{title}</h3>
            <span class={setVoteClass(vote_average)} >{vote_average}</span>
        </div>
        <div className="overview">
            <h2>Overview: </h2>
            <p>{overview}</p>
        </div>
    </div>
);

export default Movie;